export default "__VITE_ASSET__Do7tcS_c__"